import { Suspense, lazy, useEffect } from 'react';

const Root = lazy(() => import('./root'));

export function App() {
	useEffect(() => {
		const el = document.getElementById('main-loader');
		if (el) {
			el.remove();
		}
	}, []);

	return (
		<Suspense fallback={<FallbackComponent />}>
			<Root />
		</Suspense>
	);
}

function FallbackComponent() {
	return (
		<div className="bg-base-200 dark:bg-dark-100 fixed top-0 left-0 flex h-screen w-screen flex-col items-center justify-center gap-4 transition-colors">
			<div className="flex w-full items-center justify-center gap-2">
				<div className="bg-primary h-5 w-5 animate-bounce rounded-full"></div>
				<div className="bg-primary h-5 w-5 animate-bounce rounded-full delay-200"></div>
				<div className="bg-primary h-5 w-5 animate-bounce rounded-full delay-400"></div>
			</div>
		</div>
	);
}
